import React from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import classnames from "classnames";
import { Icon } from "@lifepay/rc-ui-toolkit";

import phonecallSVG from "@lifepay/assets/sprites/feather/communication/phone-call.svg";

import styles from "./Call.m.scss";

function Call(props) {
  const { theme, item } = props;

  return (
    <div className={classnames(theme.wrapper)}>
      <div className={classnames(theme.phone)}>
        {item.status === "started" && (
          <Icon
            sprite={phonecallSVG}
            theme={{
              wrapper: theme["call-icon"],
            }}
          />
        )}
        <div className={classnames(theme.number)}>{item.clientPhone}</div>
      </div>
      {item.client ? (
        <div className={classnames(theme.name)}>
          {item.client.data.clientName}
        </div>
      ) : (
        <div
          className={classnames(theme["not-found"])}
        >{`Клиент не определен`}</div>
      )}
    </div>
  );
}

Call.displayName = "Call";

Call.propTypes = {
  theme: PropTypes.object,
  item: PropTypes.object,
};

Call.defaultProps = {};

export default themr("@lifepay/Call", styles)(Call);



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-client/side-menu/ClientsList/Call/Call.js